<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="part" id="pt01">
<h1 class="pn"><a class="page" id="p10"></a><a class="page" id="p11"></a><a class="xref" href="#/nyuskousen0007#rpt01">PART I</a></h1>
<h1 class="pt">THE STRUCTURE OF PRODUCTION: A HISTORICAL SURVEY</h1>
<div class="epigraph">
<p class="eps">A study of the history of opinion is a necessary preliminary to the emancipation of the mind.—Lord Keynes</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nyu-skousen-0012.vue?a88811fa